import duotone from 'icons/duotone';
import { API_ENDPOINTS } from '../../Network/apiEndpoints';
import axios from 'axios';

// Export navigation items structure for use in other components
export const getAllNavigationItems = (userRole = '', districtCount = '0') => {
  return [
    {
      name: 'Dashboard',
      path: userRole === 'Admin' ? '/dashboard/analytics' : '/login',
      icon: duotone.Dashboard,
      badge: {
        value: districtCount
      },
      permission: 'dashboard' // Can also check 'analytics'
    },
    {
      name: 'App Order',
      icon: duotone.DataTable,
      path: '/dashboard/orders-management',
      permission: 'appOrders'
    },
    {
      name: 'Agronomist',
      icon: duotone.PersonChalkboard,
      path: '/dashboard/agronomist',
      permission: 'talkToAgronomist'
    },
    {
      name: 'Bulk Order',
      icon: duotone.LayerGroup,
      path: '/dashboard/bulk-upload',
      permission: 'bulkOrders'
    },
    {
      name: 'Return & Cancel Request',
      icon: duotone.LayerGroup,
      path: '/dashboard/return-cancel-request',
      permission: 'returnCancelRequest'
    },
    {
      name: 'Quotation/Proforma Invoice',
      icon: duotone.FileCircleQuotation,
      path: '/dashboard/Quotation-proforma',
      permission: 'quotation'
    },
    {
      name: 'Farmers',
      icon: duotone.UserList,
      path: '/dashboard/farmers',
      permission: 'farmerManagement'
    },
    {
      name: 'Agri-store',
      icon: duotone.Ecommerce,
      path: '/dashboard/products-management',
      permission: 'agriStore'
    },
    {
      name: 'Translated Content',
      icon: duotone.ElementHub,
      path: '/dashboard/groceries',
      permission: 'groceries'
    },
    {
      name: 'Posts',
      icon: duotone.Chat,
      path: '/dashboard/posts',
      permission: 'farmerForum'
    },
    {
      name: 'Knowledge Hub ',
      icon: duotone.Pages,
      path: '/dashboard/courses',
      permission: 'successStories'
    },
    {
      name: 'Event Types',
      icon: duotone.Calender,
      path: '/dashboard/event-types',
      permission: 'eventType'
    },
    {
      name: 'Crop Types',
      icon: duotone.DiagramProject,
      path: '/dashboard/crop-types',
      permission: 'cropType'
    },
    {
      name: 'Enquiry Form',
      icon: duotone.FileCircleQuestion,
      path: '/dashboard/enquiry-form',
      permission: 'enquiry'
    },
    {
      name: 'Field Visit',
      icon: duotone.PersonCircleCheck,
      path: '/dashboard/field-visit',
      permission: 'fieldVisit'
    },

    {
      name: 'Category',
      icon: duotone.Invoice,
      path: '/dashboard/invoice',
      permission: 'invoice'
    },
   
    {
      name: 'Crop Hub',
      icon: duotone.Plant,
      path: '/dashboard/crop-hub',
      permission: 'cropHub'
    },
    {
      name: 'Disease Advisory',
      icon: duotone.CommentsQuestionCheck,
      path: '/dashboard/disease-advisory',
      permission: 'diseaseAdvisory'
    },
    {
      name: 'AI Chat Bot',
      icon: duotone.Chat,
      path: '/dashboard/ai-chat-bot',
      permission: 'aiChatBot'
    },
    {
      name: 'Users',
      icon: duotone.Accounts,
      path: '/dashboard/users',
      permission: 'users'
    },
    {
      name: 'Permissions',
      icon: duotone.TodoList,
      path: '/dashboard/permissions',
      permission: 'permissions'
    },
    
  ];
};

export const navigations = await (async () => {
  const loggedData = JSON.parse(localStorage.getItem("logged_data")) || {};
  const userRole = loggedData?.data?.user_type || '';
  const permissions = loggedData?.data?.permissions || {};
  const chapterId = loggedData?.data?.chapter_id || '';
  
  // Fetch district count first
  let districtCount = '0';
  
  // if (userRole === 'chapter_admin') {
  //   try {
  //     const response = await axios.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.GET_member_count_by_chapters+ `?chapter_id=${chapterId}`);
  //     if (response.data.success) {
  //       districtCount = response.data.data.member_count.toString();
  //     }
  //   } catch (error) {
  //     console.error('Error fetching district count:', error);
  //   }
  // }
  // else{
  //   try {
  //     const response = await axios.get(API_ENDPOINTS.BASE_URL + API_ENDPOINTS.GET_district_count);
  //     if (response.data.success) {
  //       districtCount = response.data.data.district_count.toString();
  //     }
  //   } catch (error) {
  //     console.error('Error fetching district count:', error);
  //   }
  // }

  
  const allNavigations = getAllNavigationItems(userRole, districtCount);

  // Filter navigation based on permissions
  // If permissions object exists and has keys, filter by permissions
  // Otherwise, fall back to role-based filtering for backward compatibility
  if (permissions && Object.keys(permissions).length > 0) {
    return allNavigations.filter(nav => {
      // Dashboard is special - show if dashboard OR analytics permission is true
      if (nav.name === 'Dashboard') {
        return permissions.dashboard === true || permissions.analytics === true;
      }
      // For all other items, check their specific permission
      return permissions[nav.permission] === true;
    });
  }
  
  // Fallback to role-based filtering if permissions are not available
  if (userRole === 'Admin' || userRole === 'Company') {
    return [
      allNavigations[0],  // Dashboard
      allNavigations[1],  // App Order
      allNavigations[3],  // Bulk Upload
      allNavigations[4],  // Quotation/Proforma Invoice
      allNavigations[12], // Enquiry Form
      allNavigations[13], // Field Visit
      allNavigations[2],  // Agronomist
      allNavigations[6],  // Agri-store
      allNavigations[7],  // Groceries
      allNavigations[5],  // Farmers
      allNavigations[10], // Event Types
      allNavigations[11], // Crop Types
      allNavigations[8],  // Posts
      allNavigations[9],  // Knowledge Hub 
      allNavigations[14], // Crop Hub
      allNavigations[15], // Disease Advisory
      allNavigations[16], // AI Chat Bot
      allNavigations[17], // Permission
      allNavigations[18], // Invoice
      allNavigations[19], // Invoice
      allNavigations[20], // Return & Cancel Request



    ];
  } else if (userRole === 'chapter_admin') {
    return [
      allNavigations[0], // Dashboard
      allNavigations[1]  // App Order
    ];
  }

  return []; // Return empty array if no role matched
})();